import { gql } from 'apollo-boost';

const homePageQuery = gql`
  query ($limit: Int, $offset: Int) {
    entry(uri: "decode", site: "decode") {
      title
      _count(field: "decodeHomepagePosters")
      ... on decodeHomepage_decodeHomepage_Entry {
        decodeHomepagePosters(limit: $limit, offset: $offset, orderBy: "sortOrder") {
          ... on decodeHomepagePosters_set_BlockType {
            sortOrder
            setType
            id
            poster(orderBy: "sortOrder") {
              ... on poster_BlockType {
                sortOrder
                posterBlockType
                posterBreakerOrientation
                posterRatio
                offsetSettings
                contentTitle
                contentAssets {
                  url
                  title
                }
                blendMode
                linkOut {
                  ... on linkOut_internalLink_BlockType {
                    contentAsset {
                      uri
                      postDate
                      ... on decodeArticleDetailPage_decodeArticleDetail_Entry {
                        category {
                          title
                          slug
                        }
                      }
                    }
                  }
                  ... on linkOut_externalLink_BlockType {
                    dateCreated
                    externalHeader
                    paragraph
                    ctaText
                    ctaUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default homePageQuery;
